module.exports = __webpack_public_path__ + "static/media/04-Follo-Complete-campaign.04e9e9ea.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/statsradio/modules/tutorials/assets/pdfs/follo/en/04-Follo-Complete-campaign.pdf
// module id = ./src/statsradio/modules/tutorials/assets/pdfs/follo/en/04-Follo-Complete-campaign.pdf
// module chunks = 18